// Lightweight analytics. Sends events as sendBeacon POSTs to /api/event when
// a worker endpoint is configured, otherwise just console.log. Marketing can
// pipe these to PostHog / Segment / GA4 by extending the worker.

type EventName =
  | 'game_loaded'
  | 'game_started'
  | 'asset_searched'
  | 'asset_picked'
  | 'asset_scanned'
  | 'asset_patched'
  | 'asset_exploited'
  | 'cve_hit'
  | 'all_patched'
  | 'boss_started'
  | 'boss_phase2'
  | 'boss_phase3'
  | 'boss_win'
  | 'waf_deployed'
  | 'snippet_hit'
  | 'won_phase'
  | 'lost_health'
  | 'lost_timeout'
  | 'lost_boss'
  | 'cta_shown'
  | 'cta_clicked'
  | 'shared';

let sessionId: string | null = null;
const getSessionId = () => {
  if (sessionId) return sessionId;
  sessionId = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
  return sessionId;
};

export const track = (event: EventName, props: Record<string, unknown> = {}): void => {
  const payload = {
    event,
    props,
    ts: Date.now(),
    sid: getSessionId(),
    path: window.location.pathname + window.location.search,
  };
  if ((import.meta as { env?: { DEV?: boolean } }).env?.DEV) {
    console.log('[analytics]', event, props);
  }
  try {
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/event', blob);
    } else {
      fetch('/api/event', {
        method: 'POST',
        body: blob,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // best-effort; swallow
  }
};
